// extracted by mini-css-extract-plugin
export var cartContainer = "_my-4";
export var gray = "_my-1";
export var itemContainer = "_my-2";
export var itemDetails = "_my-3";
export var strong = "_my-0";